
export const contractAddresses = {
  
 
 
 
 

  flashLender: {
    56: "0x6936802F5f08618f68B3A4B3Aa4eF0DE028A9bA7",
    97: "0x6936802F5f08618f68B3A4B3Aa4eF0DE028A9bA7"
  },

  flashBorrower: {
    56: "0xe38CcfC772a40e1DAd9fA0765F4b8c5BA5eBa3be",
    97: "0xe38CcfC772a40e1DAd9fA0765F4b8c5BA5eBa3be"
  },

  flashMinter: {
    56: "0x4916eFa74Ae475DEAf5958dE64d7934a4D18cc5D",
    97: "0x4916eFa74Ae475DEAf5958dE64d7934a4D18cc5D"
  },

  flashBorrower2: {
    56: "0x898131442740a764071a035c5e5fC4f8C57061c2",
    97: "0x898131442740a764071a035c5e5fC4f8C57061c2"
  },

  

  

 
};

